import { render, staticRenderFns } from "./button-play-audio.vue?vue&type=template&id=b271e5b4&scoped=true"
import script from "./button-play-audio.vue?vue&type=script&lang=js"
export * from "./button-play-audio.vue?vue&type=script&lang=js"
import style0 from "./button-play-audio.vue?vue&type=style&index=0&id=b271e5b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b271e5b4",
  null
  
)

export default component.exports